import { api } from "./index.ts";

export interface Category {
    id: string;
    name: string;
    entity_type: string;
    created_at: string;
    updated_at: string;
}

export interface Service {
    id: string;
    title: string;
    description: string;
    price: number | null;
    images: string[];
    category: Category;
    created_at: string;
    updated_at: string;
    similar?: Service[];
}

export async function getServices(): Promise<Service[]> {
    try {
        const response = await api.get("/services");
        return response.data.services || response.data || [];
    } catch (err) {
        return [];
    }
}

export async function getService(id: string): Promise<Service | null> {
    try {
        const response = await api.get(`/services/${id}`);
        return response.data.service || response.data || null;
    } catch (err) {
        return null;
    }
}

export async function getCategories(): Promise<Category[]> {
    try {
        const response = await api.get("/categories");
        return response.data.categories || response.data || [];
    } catch (err) {
        return [];
    }
}

export async function addService(payload: {
    title: string;
    description: string;
    category_id: string;
    images: string[];
    price: number | null;
    similar_ids: string[];
}) {
    try {
        const requestData: any = {
            title: payload.title,
            description: payload.description,
            category_id: payload.category_id,
            images: Array.isArray(payload.images) ? payload.images : [],
            price: payload.price,
            similar_ids: Array.isArray(payload.similar_ids) ? payload.similar_ids : []
        };

        const response = await api.post("/services", { service: requestData });
        return response.data.service || response.data;
    } catch (err: any) {
        if (err.response) console.error("Детали ошибки:", err.response.data);
        throw err;
    }
}

export async function updateService(id: string, payload: {
    title: string;
    description: string;
    category_id: string;
    images: string[];
    price: number | null;
    similar_ids: string[];
}) {
    try {
        const requestData: any = {
            title: payload.title,
            description: payload.description,
            category_id: payload.category_id,
            images: Array.isArray(payload.images) ? payload.images : [],
            price: payload.price,
            similar_ids: Array.isArray(payload.similar_ids) ? payload.similar_ids : []
        };

        const putResp = await api.put(`/services/${id}`, { service: requestData });

        if (putResp.data && (putResp.data.service || putResp.data.id)) {
            return putResp.data.service || putResp.data;
        }

        const fresh = await getService(id);
        if (fresh) return fresh;

        const all = await getServices();
        const found = (all || []).find((s: any) => s && s.id === id);
        if (found) return found;

        return putResp.data;
    } catch (err: any) {
        if (err.response) console.error("Детали ошибки:", err.response.data);
        throw err;
    }
}

export async function deleteService(id: string) {
    try {
        await api.delete(`/services/${id}`);
        return true;
    } catch (err) {
        throw err;
    }
}